export default __webpack_public_path__ + "static/media/mastercard.fee2b8c6.webp";